import { render } from "./ExamTableList.vue?vue&type=template&id=8c8a50f0&scoped=true"
import script from "./ExamTableList.vue?vue&type=script&lang=js"
export * from "./ExamTableList.vue?vue&type=script&lang=js"

import "./ExamTableList.vue?vue&type=style&index=0&id=8c8a50f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c8a50f0"]])

export default __exports__